const coreWalletPaymentFailureTypesForSelection = ['ChargeBack', 'DirectDebitReturn'].map(key => {
	return { id: key, name: key };
});

const coreWalletPaymentFailureStatusForSelection = [
	'Created',
	'Pending',
	'DisputeInProgress',
	'DisputeWon',
	'DisputeLost'
].map(key => {
	return { id: key, name: key };
});

export { coreWalletPaymentFailureTypesForSelection, coreWalletPaymentFailureStatusForSelection };
